<!-- spinner.component.html -->
<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
  <img src="../../assets/images/Spinner/spinnerBlue.png">
  </div>
</div>